module.exports = __webpack_public_path__ + "static/media/Build.c736ac85.svg";